/**
 * 房间名的中英对照。
 *
 * 房间是自由文本（用户想怎么叫就怎么叫），但同一份方案要出中文工厂版和英文客户版，
 * 所以这里维护一份常用叫法的对照表：填中文，英文版自动出英文；填英文，中文版自动出中文。
 * 表里没有的自定义房间名原样输出——宁可保留用户写的，也不瞎翻译。
 */
export const ROOM_LABELS: Array<{ zh: string; en: string }> = [
  { zh: "中厨", en: "Main Kitchen" },
  { zh: "西厨", en: "Western Kitchen" },
  { zh: "厨房", en: "Kitchen" },
  { zh: "餐厅", en: "Dining Room" },
  { zh: "客厅", en: "Living Room" },
  { zh: "主卧", en: "Master Bedroom" },
  { zh: "次卧", en: "Guest Bedroom" },
  { zh: "儿童房", en: "Kids Room" },
  { zh: "书房", en: "Study" },
  { zh: "衣帽间", en: "Walk-in Closet" },
  { zh: "卫生间", en: "Bathroom" },
  { zh: "主卫", en: "Master Bathroom" },
  { zh: "客卫", en: "Guest Bathroom" },
  { zh: "洗衣房", en: "Laundry" },
  { zh: "阳台", en: "Balcony" },
  { zh: "玄关", en: "Entryway" },
  { zh: "车库", en: "Garage" },
  { zh: "地下室", en: "Basement" },
  { zh: "一层", en: "Level 1" },
  { zh: "二层", en: "Level 2" },
];

/** 房间名按目标语言输出；表里没有就原样返回。 */
export function roomLabel(room: string | null | undefined, language: "zh" | "en"): string | null {
  const value = room?.trim();
  if (!value) return null;
  const hit = ROOM_LABELS.find(
    (entry) => entry.zh === value || entry.en.toLowerCase() === value.toLowerCase(),
  );
  if (!hit) return value;
  return language === "en" ? hit.en : hit.zh;
}

/**
 * 房间候选里显示成「中厨 · Main Kitchen」，用户一眼就知道中英两种版本各输出什么。
 * 自定义房间名没有对照关系，只显示原文。
 */
export function roomOptionText(room: string): string {
  const entry = ROOM_LABELS.find(
    (candidate) => candidate.zh === room || candidate.en.toLowerCase() === room.toLowerCase(),
  );
  return entry ? `${entry.zh} · ${entry.en}` : room;
}
